/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
export type GQLVipFragment = {
  __typename?: 'PublicProfile'
  vip: {
    __typename?: 'Vip'
    active: boolean
    presentVip?: {
      __typename?: 'PublicPresentVip'
      days: number
      hidden: boolean
      presenter?: {
        __typename?: 'PublicProfile'
        id: any
        name: string
        gender: Types.GQLGender
        age?: number | null
        online?: {
          __typename?: 'Online'
          status: boolean
          description: any
        } | null
        verification: { __typename?: 'Verification'; verifiedPhotos: boolean }
        location: { __typename?: 'Location'; name: string }
        photos: {
          __typename?: 'ProfilePhotos'
          default?: {
            __typename?: 'Photo'
            id: any
            urls: {
              __typename?: 'PhotoUrls'
              squareSmall: string
              square: string
              squareLarge: string
              huge: string
            }
          } | null
        }
      } | null
    } | null
  }
}

export const VipFragmentDoc = gql`
  fragment Vip on PublicProfile {
    vip {
      active
      presentVip {
        days
        hidden
        presenter {
          id
          name
          gender
          online {
            status
            description
          }
          verification {
            verifiedPhotos
          }
          location {
            name
          }
          age
          photos {
            default {
              id
              urls {
                squareSmall
                square
                squareLarge
                huge
              }
            }
          }
        }
      }
    }
  }
`
